import { render, staticRenderFns } from "./WarningYears.vue?vue&type=template&id=23767a69"
import script from "./WarningYears.vue?vue&type=script&lang=js"
export * from "./WarningYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports